/* @ngInject */
export default function NvFilePreview() {
  return {
    restrict: 'A',
    templateUrl: 'shared/templates/nv-file-preview.html',
  };
}
